import { type ReactNode, type ReactElement } from 'react'
import { Card, type CardProps, Stack, Text } from '@mantine/core'

type TCardProps = CardProps

type HeaderProps = {
  children: ReactNode
}

type TitleProps = {
  children: ReactNode
}

type DescriptionProps = {
  children: ReactNode
}

type ContentProps = {
  children: ReactNode
  className?: string
}

const Header = ({ children }: HeaderProps): ReactElement => <Stack gap={0}>{children}</Stack>

const Title = ({ children }: TitleProps): ReactElement => (
  <Text fw={700} size='md'>
    {children}
  </Text>
)

const Description = ({ children }: DescriptionProps): ReactElement => (
  <Text size='sm' c='dimmed'>
    {children}
  </Text>
)

const Content = ({ children, className }: ContentProps): ReactElement => <div className={className}>{children}</div>

const TCardRoot = ({ children, ...cardProps }: TCardProps): ReactElement => (
  <Card withBorder {...cardProps}>
    <Stack gap='xs'>{children}</Stack>
  </Card>
)

export const TCard = Object.assign(TCardRoot, {
  Header,
  Title,
  Description,
  Content,
})
